// Fixed values from docs/01-datamodel.md — the single source of truth for
// every enum both the API (validation) and the UI (display) reference.
export const SUBJECT_STATUSES = ["active", "archived"];
// Same fixed palette for Subject.color and Node.color.
export const PALETTE = [
    "#6a28c0",
    "#b8901a",
    "#c44820",
    "#1e7858",
    "#1e7a8c",
    "#b02040",
    "#8040d8",
    "#1a0a2e",
];
export const EVENT_TYPES = [
    "test",
    "assignment",
    "exam",
    "deadline",
    "reminder",
    "custom",
];
export const RELATIONSHIP_TYPES = [
    "related",
    "supports",
    "contrasts",
    "causes",
    "partOf",
    "dependsOn",
];
export const QUESTION_TYPES = [
    "multipleChoice",
    "multiSelect",
    "trueFalse",
    "freeText",
];
export const TEST_ATTEMPT_STATUSES = [
    "inProgress",
    "submitted",
    "marked",
    "abandoned",
];
export const WRITING_FORMAT = "markdown";
// "superadmin" is granted by the SUPERADMIN_EMAILS deployment setting and
// re-derived on every sign-in — users.role only mirrors it. See
// docs/20-superadmin-impersonation.md.
export const USER_ROLES = ["user", "superadmin"];
// Every kind of thing a user owns, as listed by the inventory screen.
export const INVENTORY_KINDS = ["subject", "chapter", "map", "test", "task", "event"];
